function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.475 8.438a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v4.5h4.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4.5v4.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-4.5h-4.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4.5v-4.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.618 18.831c-2.752-6.514.267-14.038 6.743-16.807 6.476-2.768 13.957.268 16.71 6.782a12.874 12.874 0 01-2.71 14.072l6.637 7.12a1.082 1.082 0 01-.049 1.523 1.066 1.066 0 01-1.514-.049l-6.712-7.202c-.734.523-1.534.975-2.395 1.343-6.476 2.768-13.957-.268-16.71-6.782zm7.58-14.824C4.812 6.31 2.3 12.57 4.59 17.988c2.29 5.42 8.514 7.945 13.901 5.643 5.388-2.303 7.9-8.563 5.61-13.982-2.29-5.42-8.514-7.945-13.901-5.642z",
  fill: "currentColor"
})));